import { partition } from 'lodash-es';

const NEW_ACTIONS_MAP = new Map([
  [0, 'none'],
  [1, 'track'],
  [2, 'notify'],
]);

/**
 * Small helper to make sure that the `latitude`, `longitude` & the
 * `enter_action` and `exit_action` have the correct values.
 *
 * @param {Object} jobSite The payload to create/update the job site
 * @returns {Object} A payload the the new backend understands
 */
export function prepareJobSitePayload({ groups, latitude, longitude, position = {}, ...rest }) {
  return {
    ...rest,
    latitude: latitude || position.lat,
    longitude: longitude || position.lng,
    groups: groups.map(({ enter_action: enterAction, exit_action: exitAction, ...group }) => ({
      ...group,
      exit_action: mapActionToNewEnum(exitAction),
      enter_action: mapActionToNewEnum(enterAction),
    })),
  };
}

/**
 * Helper function to convert the old `*_action` to the new `*_action` `str_enum`.
 *
 * @param {Number|String} action The action that we have to convert to the new enum
 * @returns String
 */
export function mapActionToNewEnum(action) {
  return typeof action === 'number' ? NEW_ACTIONS_MAP.get(action) : action;
}

/**
 * Helper to create the necessary ids for the Teams and Members select
 * without clashing with the existing ids between the two entities.
 *
 * i.e: team.id = 1 & member.id = 1
 *      => team.id = team-1 & member.id = member-1
 *         team._id = 1 & member._id = 1
 *         team.type = 'team' & member.type = 'member'
 *
 * @param {Number} id Id for the entity
 * @param {String} type The identifier for the entity (team or member)
 * @returns {Object}
 */
export function getIdsForOptionType(id, type) {
  return {
    type,
    _id: id,
    id: `${type}-${id}`,
  };
}

/**
 * Helper to separate the users and the teams from the "selected" ids in rules.
 *
 * @param {Array} allIds Mixed array of ids with the form of `member-1` or `team-1`
 * @returns {Array} Array arrays with grouped ids based on `[teamIds, memberIds]`
 */
export function partitionTeamsMembersIds(allIds) {
  return partition(allIds, (id) => id.startsWith('team-'));
}
